import { useRouteMatch } from 'react-router-dom'
import { useEffect } from 'react'

import { apiManager } from 'helpers'
import { useAuthState } from 'hooks'
import { useHistory } from 'react-router'

const useReferralInvite = () => {
  const history = useHistory()
  const match = useRouteMatch()
  const { user } = useAuthState()

  const referralCode = match?.params?.referralCode

  useEffect(
    () => {
      if (user?.id && referralCode) {
        apiManager
          .updateInviteReferralCode({ referralCode })
          .then(() => {
            history.replace('/')
          })
          .catch(console.error)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user?.id, referralCode]
  )
}

export default useReferralInvite
